(function () {
    function initSearch() {
        console.log('Initializing Search Module...');
        const searchOpenBtn = document.getElementById('search-btn');
        const searchCloseBtn = document.getElementById('close-search');
        const searchOverlay = document.getElementById('search-overlay');
        const searchModalContent = document.getElementById('search-modal-content');
        const searchInput = document.getElementById('search-input');
        
        const searchResultsContainer = document.getElementById('search-results-container');
        const searchResultsList = document.getElementById('search-results-list');
        const trendingContainer = document.getElementById('trending-container');
        const recentlyViewedContainer = document.getElementById('recently-viewed-container');
        const recentlyViewedList = document.getElementById('recently-viewed-list');
        const clearRecentlyBtn = document.getElementById('clear-recently-viewed');
        const noResults = document.getElementById('no-results');
        const queryDisplay = document.getElementById('search-query-display');

        if (!searchOverlay || !searchOpenBtn) {
            console.warn('Search elements search-btn or search-overlay not found in DOM.');
            return;
        }

        console.log('Search elements found, attaching listeners.');

        function openSearch() {
            searchOverlay.classList.remove('hidden');
            searchOverlay.classList.add('flex');
            setTimeout(() => {
                searchOverlay.classList.add('is-open');
                searchModalContent?.classList.remove('scale-95', 'opacity-0');
                searchModalContent?.classList.add('scale-100', 'opacity-100');
                searchInput?.focus();
            }, 10);
            document.body.classList.add('overflow-hidden');
            renderRecentlyViewed();
        }

        function closeSearch() {
            searchOverlay.classList.remove('is-open');
            searchModalContent?.classList.remove('scale-100', 'opacity-100');
            searchModalContent?.classList.add('scale-95', 'opacity-0');
            setTimeout(() => {
                searchOverlay.classList.add('hidden');
                searchOverlay.classList.remove('flex');
            }, 300);
            document.body.classList.remove('overflow-hidden');
            if (searchInput) searchInput.value = '';
            resetSearch();
        }

        function resetSearch() {
            searchResultsContainer?.classList.add('hidden');
            trendingContainer?.classList.add('block');
            trendingContainer?.classList.remove('hidden');
            noResults?.classList.add('hidden');
        }

        // Remove old listeners to avoid duplicates
        const newSearchBtn = searchOpenBtn.cloneNode(true);
        searchOpenBtn.parentNode.replaceChild(newSearchBtn, searchOpenBtn);
        
        newSearchBtn.addEventListener('click', (e) => {
            e.preventDefault();
            console.log('Search button clicked');
            openSearch();
        });

        searchCloseBtn?.addEventListener('click', closeSearch);
        searchOverlay.addEventListener('click', (e) => {
            if (e.target === searchOverlay) closeSearch();
        });

        // Search Input Logic
        let searchTimeout;
        searchInput?.addEventListener('input', (e) => {
            const query = e.target.value.trim();
            clearTimeout(searchTimeout);
            if (query.length < 2) {
                resetSearch();
                return;
            }
            searchTimeout = setTimeout(() => performSearch(query), 300);
        });

        async function performSearch(query) {
            if (!searchResultsList || !trendingContainer || !searchResultsContainer || !noResults || !queryDisplay) return;
            try {
                const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4&section_id=predictive-search`);
                const data = await response.json();
                const products = data.resources.results.products;

                trendingContainer.classList.add('hidden');
                searchResultsContainer.classList.remove('hidden');

                if (products && products.length > 0) {
                    noResults.classList.add('hidden');
                    searchResultsList.innerHTML = products.map(product => `
                        <a href="${product.url}" class="group cursor-pointer block">
                            <div class="aspect-square bg-gray-100 rounded-xl overflow-hidden mb-4">
                                <img src="${product.image}" width="300" height="300" class="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500" alt="${product.title}" title="${product.title}">
                            </div>
                            <div class="font-['Signika_Negative',sans-serif] text-[13px] font-semibold text-gray-900 leading-tight mb-2">${product.title}</div>
                            <p class="text-[13px] font-bold text-[#FFB800]">${product.price}</p>
                        </a>
                    `).join('');
                } else {
                    searchResultsList.innerHTML = '';
                    noResults.classList.remove('hidden');
                    queryDisplay.textContent = query;
                }
            } catch (error) {
                console.error('Search failed:', error);
            }
        }

        function renderRecentlyViewed() {
            if (!recentlyViewedContainer || !recentlyViewedList) return;
            const handles = JSON.parse(localStorage.getItem('recently_viewed') || '[]');
            if (handles.length === 0) {
                recentlyViewedContainer.classList.add('hidden');
                return;
            }
            recentlyViewedContainer.classList.remove('hidden');
            recentlyViewedList.innerHTML = '';

            handles.slice(0, 2).forEach(async (handle) => {
                try {
                    const res = await fetch(`/products/${handle}.js`);
                    const product = await res.json();
                    const item = document.createElement('div');
                    item.className = 'flex gap-3 md:gap-4 group cursor-pointer p-2 md:p-3 rounded-lg md:rounded-xl';
                    item.innerHTML = `
                        <a href="${product.url}" class="flex gap-3 md:gap-4 w-full">
                            <div class="w-20 h-20 md:w-24 md:h-24 bg-gray-100 rounded-lg overflow-hidden flex-shrink-0">
                                <img src="${product.featured_image}" width="100" height="100" class="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500" alt="${product.title}" title="${product.title}">
                            </div>
                            <div class="flex flex-col justify-center text-left">
                                <div class="font-['Signika_Negative',sans-serif] text-xs md:text-sm font-semibold text-gray-900 leading-tight mb-1 md:mb-2">${product.title}</div>
                                <p class="text-xs md:text-sm font-bold text-[#FFB800]">Rs. ${(product.price / 100).toFixed(2)} INR</p>
                            </div>
                        </a>
                    `;
                    recentlyViewedList.appendChild(item);
                } catch (e) {}
            });
        }

        clearRecentlyBtn?.addEventListener('click', () => {
            localStorage.removeItem('recently_viewed');
            recentlyViewedContainer?.classList.add('hidden');
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && searchOverlay.classList.contains('is-open')) closeSearch();
        });
    }

    // Initialize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSearch);
    } else {
        initSearch();
    }

    // Shopify Theme Editor Support
    document.addEventListener('shopify:section:load', (e) => {
        if (e.target.classList.contains('section-header')) {
            initSearch();
        }
    });
  })();
